import React from 'react';

import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import {cancelROLAutoProfile, finishROLAutoProfile, recoverROLAutoProfile} from '@/businesses/autoProfileBusiness';
import InputField from '@/components/inputfield/InputField';
import IntlMessage from '@/components/intlMessage/IntlMessage';
import PopUpButtons from '@/components/popup/PopUpButtons';
import StandalonePopUp from '@/components/popup/StandalonePopUp';
import ToggleButtonCustom from '@/components/togglebutton/src/ToggleButtonCustom';
import {RecoveryOfLiquidAction, RecoveryNumberOfPump, RecoveryOfLiquidMode} from '@/constants/autoProfileEnum';
import {NO_LIMIT, RECOVERY_FINAL_VOL_THRESHOLD} from '@/constants/configurations';
import * as APPDATA from '@/constants/pcConstAppData';
import {RecoveryOfLiquidEvent} from '@/constants/pubSubEnum';
import withIntl from '@/libs/withIntl';
import {eventBusObject} from '@/observers/eventBus';

import './RecoveryOfLiquidModal.less';

const DISPLAY_NAME = 'sample-recovery-auto-profile-modal';

@connect((store) => ({
  isStopingFromButton: store.setupStore.isStopingFromButton,
  profileRunningConfig: store.setupStore.profileRunning.Config,
  currentVolume: store.setupStore.currentVolume,
  IsManualControlEnable: store.manualControlStore.StatusManualControl.IsManualControlEnable,
  isFromStopProfile: store.setupStore.isFromStopProfile,
  isRecoveryClicked: store.setupStore.isRecoveryClicked,
  autoProfileSetupMode: store.setupStore.autoProfileSetupMode,
  isRecoveryFromErrorProfile: store.setupStore.isRecoveryFromErrorProfile,
}))
class RecoveryOfLiquidModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      recoveryAction: null,
      selectedRecoveryOfLiquid: RecoveryOfLiquidMode.NONE,
      numberOfPumps: 8,
      isDisableBufferInput: true,
      calculator: {
        volumeToStartAt: APPDATA.EMPTY_FIELD,
        percentage: APPDATA.EMPTY_FIELD,
        stepSize: 2,
        bufferNeeded: APPDATA.EMPTY_FIELD,
        exchangeStepSize: APPDATA.EMPTY_FIELD,
        stepSizeVolume: APPDATA.EMPTY_FIELD,
        showWarning: false,
      },
    };
    this._bus = eventBusObject();
    // FIXME: please change set show modal using global state
    this._bus.subscribe(RecoveryOfLiquidEvent.SHOW_POP_UP, (e) => this.showROLPopUp(e));
    this._bus.subscribe(RecoveryOfLiquidEvent.HIDE_POP_UP, (e) => this.handleResetState(e));
  }

  handleResetState = () => {
    this.setState({
      show: false,
      recoveryAction: null,
      selectedRecoveryOfLiquid: RecoveryOfLiquidMode.NONE,
      numberOfPumps: 8,
      isDisableBufferInput: true,
      calculator: {
        volumeToStartAt: APPDATA.EMPTY_FIELD,
        percentage: APPDATA.EMPTY_FIELD,
        stepSize: 2,
        bufferNeeded: APPDATA.EMPTY_FIELD,
        exchangeStepSize: APPDATA.EMPTY_FIELD,
        stepSizeVolume: APPDATA.EMPTY_FIELD,
        showWarning: false,
      },
    });
  };

  handleRecoveryModeClick = (e) => {
    let selectedROL;
    let value;

    switch (e.currentTarget.id) {
      case APPDATA.ENUM.RECOVERY_OF_LIQUID.None:
        selectedROL = RecoveryOfLiquidMode.NONE;
        value = true;
        break;
      case APPDATA.ENUM.RECOVERY_OF_LIQUID.Buffer:
        selectedROL = RecoveryOfLiquidMode.BUFFER;
        value = false;
        break;
      case APPDATA.ENUM.RECOVERY_OF_LIQUID.Air_Buffer:
        selectedROL = RecoveryOfLiquidMode.AIR_BUFFER;
        value = false;
        break;
      case APPDATA.ENUM.RECOVERY_OF_LIQUID.Air:
        selectedROL = RecoveryOfLiquidMode.AIR;
        value = false;
        break;
      default:
        selectedROL = RecoveryOfLiquidMode.NONE;
        value = true;
        break;
    }

    this.setState({
      selectedRecoveryOfLiquid: selectedROL,
      isDisableBufferInput: value,
      numberOfPumps: RecoveryNumberOfPump[selectedROL],
      show: true,
    });
  };

  showROLPopUp = (e) => {
    this.setState({
      selectedRecoveryOfLiquid: RecoveryOfLiquidMode.NONE,
      isDisableBufferInput: true,
      numberOfPumps: RecoveryNumberOfPump[RecoveryOfLiquidMode.NONE],
      recoveryAction: e.recoveryAction,
      show: true,
    });
  };

  showNumpad = (e) => {
    const {numberOfPumps, selectedRecoveryOfLiquid} = this.state;
    const {dispatch, intl} = this.props;

    let value;
    let unit;
    const info = undefined;
    let maxValue = 0;
    let minValue = 0;

    const minVal =
      selectedRecoveryOfLiquid === RecoveryOfLiquidMode.BUFFER
        ? APPDATA.CONFIGURATION.VOLUME_BUFFER_RECOVERY.MIN_VALUE
        : APPDATA.CONFIGURATION.VOLUME_AIR_RECOVERY.MIN_VALUE;
    let maxDigitAfterDecimal = APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY;
    let incrementValue = APPDATA.CONFIGURATION.VOLUME_SENSOR.INCREMENT_VALUE;

    switch (e.currentTarget.id) {
      case intl.formatMessage({id: 'modal.sampleRecovery.inputLabel.approximateVol'}):
        value = numberOfPumps;
        unit = APPDATA.UNIT.ml;
        maxValue = NO_LIMIT;
        minValue = minVal;
        maxDigitAfterDecimal = APPDATA.CONFIGURATION.VOLUME_BUFFER_RECOVERY.DECIMAL_PLACE_ACCURACY;
        incrementValue = 1;
        break;
      default:
        break;
    }

    if (value === APPDATA.EMPTY_FIELD) value = '0';

    if (value !== undefined) {
      dispatch(
        modalActions.showModal({
          modalHeader: e.currentTarget.id,
          value,
          callback: this.handleApproximateVolChange,
          maxValue,
          minValue,
          maxDigitAfterDecimal,
          incrementValue,
          unit,
          info,
        }),
      );
    }
  };

  handleApproximateVolChange = (e) => {
    const {intl} = this.props;
    const {calculator} = this.state;

    const newCalculator = calculator;

    if (e.type) {
      switch (e.type) {
        case intl.formatMessage({id: 'modal.sampleRecovery.inputLabel.approximateVol'}):
          newCalculator.percentage = e.value;

          this.setState({
            numberOfPumps: e.value,
            isDisableBufferInput: false,
            show: true,
          });

          break;
        default:
          break;
      }

      this.setState({
        calculator: newCalculator,
        isDisableBufferInput: false,
        show: true,
      });
    }
  };

  renderTitle = () => {
    const {recoveryAction} = this.state;
    const {isStopingFromButton} = this.props;
    let titleId;

    switch (recoveryAction) {
      case RecoveryOfLiquidAction.START_RECOVERY_OF_LIQUID:
        titleId = `modal.sampleRecovery.title${!isStopingFromButton ? '.error' : ''}`;

        break;
      case RecoveryOfLiquidAction.STOP_MANUAL_CONTROL:
      case RecoveryOfLiquidAction.RECOVERY_FROM_STOP_AUTO:
      default:
        titleId = 'modal.sampleRecovery.title';

        break;
    }

    return <IntlMessage id={titleId} />;
  };

  renderBody = () => {
    const {recoveryAction, isDisableBufferInput, numberOfPumps, selectedRecoveryOfLiquid} = this.state;
    const {isStopingFromButton, intl, autoProfileSetupMode, profileRunningConfig, currentVolume, dispatch} = this.props;
    let messageId;

    switch (recoveryAction) {
      case RecoveryOfLiquidAction.START_RECOVERY_OF_LIQUID:
        messageId = `modal.sampleRecovery.message${!isStopingFromButton ? '.error' : ''}`;

        break;
      case RecoveryOfLiquidAction.STOP_MANUAL_CONTROL:
      case RecoveryOfLiquidAction.RECOVERY_FROM_STOP_AUTO:
      default:
        messageId = 'modal.sampleRecovery.message';

        break;
    }

    const isDisableRol = profileRunningConfig[APPDATA.KEY.MoreThan50ml] === 'true';

    const recoveryOfLiquidComplete = [
      {
        id: APPDATA.ENUM.RECOVERY_OF_LIQUID.Air,
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.Air,
        value: RecoveryOfLiquidMode.AIR,
      },
      {
        id: APPDATA.ENUM.RECOVERY_OF_LIQUID.Buffer,
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.Buffer,
        value: RecoveryOfLiquidMode.BUFFER,

        disabled: isDisableRol,
      },
    ];

    let estimatedVolume = parseFloat(currentVolume);
    switch (selectedRecoveryOfLiquid) {
      case RecoveryOfLiquidMode.BUFFER:
        estimatedVolume = (parseFloat(currentVolume) + parseFloat(numberOfPumps)).toFixed(2);
        break;
      case RecoveryOfLiquidMode.AIR:
        estimatedVolume = (parseFloat(currentVolume) + parseFloat(numberOfPumps)).toFixed(2);
        break;
      case RecoveryOfLiquidMode.AIR_BUFFER: {
        const estimatedVolumeBufferRecovery =
          parseFloat(numberOfPumps) *
          parseFloat(APPDATA.CONFIGURATION.RECOVERY_OF_LIQUID.VOLUME_ADD_EVERY_PUMP_BUFFER_RECOVERY);
        let estimatedVolumeAirRecovery =
          parseFloat(numberOfPumps) *
          parseFloat(APPDATA.CONFIGURATION.RECOVERY_OF_LIQUID.VOLUME_ADD_EVERY_PUMP_AIR_RECOVERY);
        if (estimatedVolumeAirRecovery > APPDATA.CONFIGURATION.RECOVERY_OF_LIQUID.MAX_VOLUME_IN_CHIP) {
          estimatedVolumeAirRecovery = APPDATA.CONFIGURATION.RECOVERY_OF_LIQUID.MAX_VOLUME_IN_CHIP;
        }
        estimatedVolume = (
          parseFloat(currentVolume) +
          estimatedVolumeBufferRecovery +
          estimatedVolumeAirRecovery
        ).toFixed(APPDATA.CONFIGURATION.RECOVERY_OF_LIQUID.DECIMAL_PLACE_ACCURACY);
        break;
      }
      default:
        break;
    }
    const isDisabledRecovery = selectedRecoveryOfLiquid === RecoveryOfLiquidMode.NONE;

    const popUpButton = [
      {
        id: APPDATA.RECOVER,
        isPrimaryButton: true,
        onClick: () => dispatch(recoverROLAutoProfile(recoveryAction, selectedRecoveryOfLiquid, numberOfPumps)),
        label: intl.formatMessage({
          id: `modal.sampleRecovery.primaryButton`,
        }),
        disabled: isDisabledRecovery,
        className: 'recovery-button',
      },
    ];
    return (
      <>
        <span>
          {intl
            .formatMessage({id: messageId})
            .split('\n')
            .map((item) => (
              <span key={item}>
                {item}
                <br />
              </span>
            ))}
        </span>
        <br />
        <div className="row center">
          <div className="col-md-11 center">
            <ToggleButtonCustom
              buttonProp={recoveryOfLiquidComplete}
              // defaultValue={RECOVERY_OF_LIQUID_TOGGLE_VALUE.None}
              value={selectedRecoveryOfLiquid}
              onClick={this.handleRecoveryModeClick}
            />
          </div>
        </div>
        {autoProfileSetupMode === APPDATA.FIELD_NAME.CONC_TWO_TUBES &&
          selectedRecoveryOfLiquid === RecoveryOfLiquidMode.BUFFER && (
            <div className="row">
              <div className="sample-info">
                {intl.formatMessage({id: 'modal.sampleRecovery.message.con2TubesModeBuffer'})}
              </div>
            </div>
          )}
        <br />
        <div className="row">
          <div>
            <InputField
              label={intl.formatMessage({id: 'modal.sampleRecovery.inputLabel.approximateVol'})}
              inputValue={numberOfPumps}
              unit={APPDATA.UNIT.ml}
              onClick={this.showNumpad}
              hideField={undefined}
              disabled={isDisableBufferInput}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="middleAlign">
            <div className="col-xs-8 col-md-8 col-lg-8 col-xl-8">
              <div className="row row-margin">
                <span
                  className="spanStyleInputField"
                  disabled={isDisableBufferInput}
                >
                  {intl.formatMessage({id: 'modal.sampleRecovery.inputLabel.estFinalVol'})}
                </span>
              </div>
            </div>
            <div className="col-xs-3 col-md-3 col-lg-3 col-xl-3 center">
              <span
                className="spanStyleInputField"
                disabled={isDisableBufferInput}
              >
                {estimatedVolume}
              </span>
            </div>
            <div className="col-xs-1 col-md-1 col-lg-1 col-xl-1 no-padding">
              <span
                className="spanStyleInputField unit"
                disabled={isDisableBufferInput}
              >
                {APPDATA.UNIT.ml}
              </span>
            </div>
          </div>
        </div>
        <div className="row center recovery">
          <PopUpButtons data={popUpButton} />
        </div>
      </>
    );
  };

  renderFooter = () => {
    const {recoveryAction} = this.state;
    const {
      isFromStopProfile,
      isRecoveryClicked,
      isRecoveryFromErrorProfile,
      IsManualControlEnable,
      profileRunningConfig,
      intl,
      dispatch,
    } = this.props;

    const isDisableBack =
      recoveryAction === RecoveryOfLiquidAction.RECOVERY_FROM_STOP_POPUP ||
      recoveryAction === RecoveryOfLiquidAction.RECOVERY_FROM_STOP_AUTO
        ? true
        : !!(
            recoveryAction === RecoveryOfLiquidAction.RECOVERY_FROM_STOP_ERROR ||
            profileRunningConfig.FinalVolume >= RECOVERY_FINAL_VOL_THRESHOLD
          );
    const isDisabledCancel = isDisableBack || (isFromStopProfile && isRecoveryClicked) || isRecoveryFromErrorProfile;

    const isRecoveryFromStop = [
      RecoveryOfLiquidAction.RECOVERY_FROM_STOP_POPUP,
      RecoveryOfLiquidAction.RECOVERY_FROM_STOP_ERROR,
    ].includes(recoveryAction);

    const popUpButton = [
      {
        id: isRecoveryFromStop || IsManualControlEnable ? APPDATA.BACK : APPDATA.CANCEL,
        onClick: () => dispatch(cancelROLAutoProfile(recoveryAction)),
        label: intl.formatMessage({
          id: `modal.sampleRecovery.ternaryButton.${isRecoveryFromStop || IsManualControlEnable ? 'back' : 'cancel'}`,
        }),
        className: 'tertiaryButton',
        disabled: isDisabledCancel,
      },
      {
        id: APPDATA.FINISH_PROFILE,
        isPrimaryButton: false,
        onClick: () => dispatch(finishROLAutoProfile(recoveryAction)),
        label: intl.formatMessage({
          id: `modal.sampleRecovery.secondaryButton`,
        }),
      },
    ];
    return (
      <StandalonePopUp.FooterActions>
        <PopUpButtons data={popUpButton} />
      </StandalonePopUp.FooterActions>
    );
  };

  render() {
    const {show} = this.state;

    return (
      <StandalonePopUp
        isPopUpVisible={show}
        dialogClassName={DISPLAY_NAME}
        contents={{
          popUpTitle: this.renderTitle(),
          popUpBody: this.renderBody(),
          popUpFooter: this.renderFooter(),
        }}
        hideCloseButton
        footerClassName="space-between"
      />
    );
  }
}

RecoveryOfLiquidModal.propTypes = {
  dispatch: PropTypes.any,
  intl: PropTypes.any,
  isStopingFromButton: PropTypes.bool,
  profileRunningConfig: PropTypes.object,
  currentVolume: PropTypes.any,
  IsManualControlEnable: PropTypes.any,
  isFromStopProfile: PropTypes.bool,
  isRecoveryClicked: PropTypes.bool,
  autoProfileSetupMode: PropTypes.string,
  isRecoveryFromErrorProfile: PropTypes.bool,
};

RecoveryOfLiquidModal.defaultProps = {
  dispatch: () => {},
  intl: {},
  isStopingFromButton: false,
  profileRunningConfig: {},
  currentVolume: '0',
  IsManualControlEnable: '',
  isFromStopProfile: false,
  isRecoveryClicked: false,
  autoProfileSetupMode: '',
  isRecoveryFromErrorProfile: false,
};

export default withIntl(RecoveryOfLiquidModal);
